function st(e) {
  return Object.keys(e).reduce((n, i) => {
    const r = e[i];
    return n[i] = Object.assign({}, r), ze(r.value) && !ut(r.value) && !Array.isArray(r.value) && (n[i].value = Object.assign({}, r.value)), Array.isArray(r.value) && (n[i].value = r.value.slice(0)), n;
  }, {});
}
function ot(e) {
  return e ? Object.keys(e).reduce((n, i) => {
    const r = e[i];
    return n[i] = ze(r) && "value" in r ? r : {
      value: r
    }, n[i].attribute || (n[i].attribute = ct(i)), n[i].parse = "parse" in n[i] ? n[i].parse : typeof n[i].value != "string", n;
  }, {}) : {};
}
function lt(e) {
  return Object.keys(e).reduce((n, i) => (n[i] = e[i].value, n), {});
}
function at(e, t) {
  const n = st(t);
  return Object.keys(t).forEach((r) => {
    const s = n[r], l = e.getAttribute(s.attribute), o = e[r];
    l && (s.value = s.parse ? Ne(l) : l), o != null && (s.value = Array.isArray(o) ? o.slice(0) : o), s.reflect && $e(e, s.attribute, s.value), Object.defineProperty(e, r, {
      get() {
        return s.value;
      },
      set(c) {
        const f = s.value;
        s.value = c, s.reflect && $e(this, s.attribute, s.value);
        for (let a = 0, u = this.__propertyChangedCallbacks.length; a < u; a++)
          this.__propertyChangedCallbacks[a](r, c, f);
      },
      enumerable: !0,
      configurable: !0
    });
  }), n;
}
function Ne(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function $e(e, t, n) {
  if (n == null || n === !1)
    return e.removeAttribute(t);
  let i = JSON.stringify(n);
  e.__updating[t] = !0, i === "true" && (i = ""), e.setAttribute(t, i), Promise.resolve().then(() => delete e.__updating[t]);
}
function ct(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, n) => "-" + n.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function ze(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function ut(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function dt(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let ue;
function ft(e, t) {
  const n = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return n.map((r) => t[r].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized)
        return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = at(this, t);
      const r = lt(this.props), s = this.Component, l = ue;
      try {
        ue = this, this.__initialized = !0, dt(s) ? new s(r, {
          element: this
        }) : s(r, {
          element: this
        });
      } finally {
        ue = l;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected)
        return;
      this.__propertyChangedCallbacks.length = 0;
      let r = null;
      for (; r = this.__releaseCallbacks.pop(); )
        r(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(r, s, l) {
      if (this.__initialized && !this.__updating[r] && (r = this.lookupProp(r), r in t)) {
        if (l == null && !this[r])
          return;
        this[r] = t[r].parse ? Ne(l) : l;
      }
    }
    lookupProp(r) {
      if (t)
        return n.find((s) => r === s || r === t[s].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(r) {
      this.__releaseCallbacks.push(r);
    }
    addPropertyChangedCallback(r) {
      this.__propertyChangedCallbacks.push(r);
    }
  };
}
function ht(e, t = {}, n = {}) {
  const {
    BaseElement: i = HTMLElement,
    extension: r
  } = n;
  return (s) => {
    if (!e)
      throw new Error("tag is required to register a Component");
    let l = customElements.get(e);
    return l ? (l.prototype.Component = s, l) : (l = ft(i, ot(t)), l.prototype.Component = s, l.prototype.registeredTag = e, customElements.define(e, l, r), l);
  };
}
const pt = (e, t) => e === t, me = Symbol("solid-proxy"), yt = Symbol("solid-track"), J = {
  equals: pt
};
let Re = De;
const M = 1, Q = 2, Ie = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
};
var w = null;
let de = null, gt = null, m = null, S = null, I = null, ne = 0;
function Z(e, t) {
  const n = m, i = w, r = e.length === 0, s = t === void 0 ? i : t, l = r ? Ie : {
    owned: null,
    cleanups: null,
    context: s ? s.context : null,
    owner: s
  }, o = r ? e : () => e(() => T(() => ie(l)));
  w = l, m = null;
  try {
    return V(o, !0);
  } finally {
    m = n, w = i;
  }
}
function j(e, t) {
  t = t ? Object.assign({}, J, t) : J;
  const n = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, i = (r) => (typeof r == "function" && (r = r(n.value)), Be(n, r));
  return [Ke.bind(n), i];
}
function A(e, t, n) {
  const i = _e(e, t, !1, M);
  q(i);
}
function Fe(e, t, n) {
  Re = Ct;
  const i = _e(e, t, !1, M);
  (!n || !n.render) && (i.user = !0), I ? I.push(i) : q(i);
}
function F(e, t, n) {
  n = n ? Object.assign({}, J, n) : J;
  const i = _e(e, t, !0, 0);
  return i.observers = null, i.observerSlots = null, i.comparator = n.equals || void 0, q(i), Ke.bind(i);
}
function mt(e) {
  return V(e, !1);
}
function T(e) {
  if (m === null)
    return e();
  const t = m;
  m = null;
  try {
    return e();
  } finally {
    m = t;
  }
}
function bt(e) {
  Fe(() => T(e));
}
function Me(e) {
  return w === null || (w.cleanups === null ? w.cleanups = [e] : w.cleanups.push(e)), e;
}
function wt(e) {
  const t = F(e), n = F(() => be(t()));
  return n.toArray = () => {
    const i = n();
    return Array.isArray(i) ? i : i != null ? [i] : [];
  }, n;
}
function Ke() {
  if (this.sources && this.state)
    if (this.state === M)
      q(this);
    else {
      const e = S;
      S = null, V(() => te(this), !1), S = e;
    }
  if (m) {
    const e = this.observers ? this.observers.length : 0;
    m.sources ? (m.sources.push(this), m.sourceSlots.push(e)) : (m.sources = [this], m.sourceSlots = [e]), this.observers ? (this.observers.push(m), this.observerSlots.push(m.sources.length - 1)) : (this.observers = [m], this.observerSlots = [m.sources.length - 1]);
  }
  return this.value;
}
function Be(e, t, n) {
  let i = e.value;
  return (!e.comparator || !e.comparator(i, t)) && (e.value = t, e.observers && e.observers.length && V(() => {
    for (let r = 0; r < e.observers.length; r += 1) {
      const s = e.observers[r], l = de && de.running;
      l && de.disposed.has(s), (l ? !s.tState : !s.state) && (s.pure ? S.push(s) : I.push(s), s.observers && Ue(s)), l || (s.state = M);
    }
    if (S.length > 1e6)
      throw S = [], new Error();
  }, !1)), t;
}
function q(e) {
  if (!e.fn)
    return;
  ie(e);
  const t = ne;
  vt(
    e,
    e.value,
    t
  );
}
function vt(e, t, n) {
  let i;
  const r = w, s = m;
  m = w = e;
  try {
    i = e.fn(t);
  } catch (l) {
    return e.pure && (e.state = M, e.owned && e.owned.forEach(ie), e.owned = null), e.updatedAt = n + 1, We(l);
  } finally {
    m = s, w = r;
  }
  (!e.updatedAt || e.updatedAt <= n) && (e.updatedAt != null && "observers" in e ? Be(e, i) : e.value = i, e.updatedAt = n);
}
function _e(e, t, n, i = M, r) {
  const s = {
    fn: e,
    state: i,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: w,
    context: w ? w.context : null,
    pure: n
  };
  return w === null || w !== Ie && (w.owned ? w.owned.push(s) : w.owned = [s]), s;
}
function ee(e) {
  if (e.state === 0)
    return;
  if (e.state === Q)
    return te(e);
  if (e.suspense && T(e.suspense.inFallback))
    return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < ne); )
    e.state && t.push(e);
  for (let n = t.length - 1; n >= 0; n--)
    if (e = t[n], e.state === M)
      q(e);
    else if (e.state === Q) {
      const i = S;
      S = null, V(() => te(e, t[0]), !1), S = i;
    }
}
function V(e, t) {
  if (S)
    return e();
  let n = !1;
  t || (S = []), I ? n = !0 : I = [], ne++;
  try {
    const i = e();
    return xt(n), i;
  } catch (i) {
    n || (I = null), S = null, We(i);
  }
}
function xt(e) {
  if (S && (De(S), S = null), e)
    return;
  const t = I;
  I = null, t.length && V(() => Re(t), !1);
}
function De(e) {
  for (let t = 0; t < e.length; t++)
    ee(e[t]);
}
function Ct(e) {
  let t, n = 0;
  for (t = 0; t < e.length; t++) {
    const i = e[t];
    i.user ? e[n++] = i : ee(i);
  }
  for (t = 0; t < n; t++)
    ee(e[t]);
}
function te(e, t) {
  e.state = 0;
  for (let n = 0; n < e.sources.length; n += 1) {
    const i = e.sources[n];
    if (i.sources) {
      const r = i.state;
      r === M ? i !== t && (!i.updatedAt || i.updatedAt < ne) && ee(i) : r === Q && te(i, t);
    }
  }
}
function Ue(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const n = e.observers[t];
    n.state || (n.state = Q, n.pure ? S.push(n) : I.push(n), n.observers && Ue(n));
  }
}
function ie(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const n = e.sources.pop(), i = e.sourceSlots.pop(), r = n.observers;
      if (r && r.length) {
        const s = r.pop(), l = n.observerSlots.pop();
        i < r.length && (s.sourceSlots[l] = i, r[i] = s, n.observerSlots[i] = l);
      }
    }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--)
      ie(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--)
      e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function Pt(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function We(e, t = w) {
  throw Pt(e);
}
function be(e) {
  if (typeof e == "function" && !e.length)
    return be(e());
  if (Array.isArray(e)) {
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const i = be(e[n]);
      Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
    }
    return t;
  }
  return e;
}
const St = Symbol("fallback");
function Ae(e) {
  for (let t = 0; t < e.length; t++)
    e[t]();
}
function _t(e, t, n = {}) {
  let i = [], r = [], s = [], l = 0, o = t.length > 1 ? [] : null;
  return Me(() => Ae(s)), () => {
    let c = e() || [], f, a;
    return c[yt], T(() => {
      let d = c.length, h, v, y, z, $, P, _, E, R;
      if (d === 0)
        l !== 0 && (Ae(s), s = [], i = [], r = [], l = 0, o && (o = [])), n.fallback && (i = [St], r[0] = Z((se) => (s[0] = se, n.fallback())), l = 1);
      else if (l === 0) {
        for (r = new Array(d), a = 0; a < d; a++)
          i[a] = c[a], r[a] = Z(u);
        l = d;
      } else {
        for (y = new Array(d), z = new Array(d), o && ($ = new Array(d)), P = 0, _ = Math.min(l, d); P < _ && i[P] === c[P]; P++)
          ;
        for (_ = l - 1, E = d - 1; _ >= P && E >= P && i[_] === c[E]; _--, E--)
          y[E] = r[_], z[E] = s[_], o && ($[E] = o[_]);
        for (h = /* @__PURE__ */ new Map(), v = new Array(E + 1), a = E; a >= P; a--)
          R = c[a], f = h.get(R), v[a] = f === void 0 ? -1 : f, h.set(R, a);
        for (f = P; f <= _; f++)
          R = i[f], a = h.get(R), a !== void 0 && a !== -1 ? (y[a] = r[f], z[a] = s[f], o && ($[a] = o[f]), a = v[a], h.set(R, a)) : s[f]();
        for (a = P; a < d; a++)
          a in y ? (r[a] = y[a], s[a] = z[a], o && (o[a] = $[a], o[a](a))) : r[a] = Z(u);
        r = r.slice(0, l = d), i = c.slice(0);
      }
      return r;
    });
    function u(d) {
      if (s[a] = d, o) {
        const [h, v] = j(a);
        return o[a] = v, t(c[a], h);
      }
      return t(c[a]);
    }
  };
}
function g(e, t) {
  return T(() => e(t || {}));
}
function Y() {
  return !0;
}
const Et = {
  get(e, t, n) {
    return t === me ? n : e.get(t);
  },
  has(e, t) {
    return t === me ? !0 : e.has(t);
  },
  set: Y,
  deleteProperty: Y,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: Y,
      deleteProperty: Y
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function fe(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function kt() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const n = this[e]();
    if (n !== void 0)
      return n;
  }
}
function $t(...e) {
  let t = !1;
  for (let l = 0; l < e.length; l++) {
    const o = e[l];
    t = t || !!o && me in o, e[l] = typeof o == "function" ? (t = !0, F(o)) : o;
  }
  if (t)
    return new Proxy(
      {
        get(l) {
          for (let o = e.length - 1; o >= 0; o--) {
            const c = fe(e[o])[l];
            if (c !== void 0)
              return c;
          }
        },
        has(l) {
          for (let o = e.length - 1; o >= 0; o--)
            if (l in fe(e[o]))
              return !0;
          return !1;
        },
        keys() {
          const l = [];
          for (let o = 0; o < e.length; o++)
            l.push(...Object.keys(fe(e[o])));
          return [...new Set(l)];
        }
      },
      Et
    );
  const n = {}, i = /* @__PURE__ */ Object.create(null);
  for (let l = e.length - 1; l >= 0; l--) {
    const o = e[l];
    if (!o)
      continue;
    const c = Object.getOwnPropertyNames(o);
    for (let f = c.length - 1; f >= 0; f--) {
      const a = c[f];
      if (a === "__proto__" || a === "constructor")
        continue;
      const u = Object.getOwnPropertyDescriptor(o, a);
      if (!i[a])
        i[a] = u.get ? {
          enumerable: !0,
          configurable: !0,
          get: kt.bind(n[a] = [u.get.bind(o)])
        } : u.value !== void 0 ? u : void 0;
      else {
        const d = n[a];
        d && (u.get ? d.push(u.get.bind(o)) : u.value !== void 0 && d.push(() => u.value));
      }
    }
  }
  const r = {}, s = Object.keys(i);
  for (let l = s.length - 1; l >= 0; l--) {
    const o = s[l], c = i[o];
    c && c.get ? Object.defineProperty(r, o, c) : r[o] = c ? c.value : void 0;
  }
  return r;
}
const Ve = (e) => `Stale read from <${e}>.`;
function At(e) {
  const t = "fallback" in e && {
    fallback: () => e.fallback
  };
  return F(_t(() => e.each, e.children, t || void 0));
}
function he(e) {
  const t = e.keyed, n = F(() => e.when, void 0, {
    equals: (i, r) => t ? i === r : !i == !r
  });
  return F(
    () => {
      const i = n();
      if (i) {
        const r = e.children;
        return typeof r == "function" && r.length > 0 ? T(
          () => r(
            t ? i : () => {
              if (!T(n))
                throw Ve("Show");
              return e.when;
            }
          )
        ) : r;
      }
      return e.fallback;
    },
    void 0,
    void 0
  );
}
function Lt(e) {
  let t = !1;
  const n = (s, l) => (t ? s[1] === l[1] : !s[1] == !l[1]) && s[2] === l[2], i = wt(() => e.children), r = F(
    () => {
      let s = i();
      Array.isArray(s) || (s = [s]);
      for (let l = 0; l < s.length; l++) {
        const o = s[l].when;
        if (o)
          return t = !!s[l].keyed, [l, o, s[l]];
      }
      return [-1];
    },
    void 0,
    {
      equals: n
    }
  );
  return F(
    () => {
      const [s, l, o] = r();
      if (s < 0)
        return e.fallback;
      const c = o.children;
      return typeof c == "function" && c.length > 0 ? T(
        () => c(
          t ? l : () => {
            if (T(r)[0] !== s)
              throw Ve("Match");
            return o.when;
          }
        )
      ) : c;
    },
    void 0,
    void 0
  );
}
function pe(e) {
  return e;
}
const Ot = [
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected"
], jt = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  ...Ot
]), Tt = /* @__PURE__ */ new Set([
  "innerHTML",
  "textContent",
  "innerText",
  "children"
]), Nt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), zt = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  }
});
function Rt(e, t) {
  const n = zt[e];
  return typeof n == "object" ? n[t] ? n.$ : void 0 : n;
}
const It = /* @__PURE__ */ new Set([
  "beforeinput",
  "click",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
]), Ft = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
};
function Mt(e, t, n) {
  let i = n.length, r = t.length, s = i, l = 0, o = 0, c = t[r - 1].nextSibling, f = null;
  for (; l < r || o < s; ) {
    if (t[l] === n[o]) {
      l++, o++;
      continue;
    }
    for (; t[r - 1] === n[s - 1]; )
      r--, s--;
    if (r === l) {
      const a = s < i ? o ? n[o - 1].nextSibling : n[s - o] : c;
      for (; o < s; )
        e.insertBefore(n[o++], a);
    } else if (s === o)
      for (; l < r; )
        (!f || !f.has(t[l])) && t[l].remove(), l++;
    else if (t[l] === n[s - 1] && n[o] === t[r - 1]) {
      const a = t[--r].nextSibling;
      e.insertBefore(n[o++], t[l++].nextSibling), e.insertBefore(n[--s], a), t[r] = n[s];
    } else {
      if (!f) {
        f = /* @__PURE__ */ new Map();
        let u = o;
        for (; u < s; )
          f.set(n[u], u++);
      }
      const a = f.get(t[l]);
      if (a != null)
        if (o < a && a < s) {
          let u = l, d = 1, h;
          for (; ++u < r && u < s && !((h = f.get(t[u])) == null || h !== a + d); )
            d++;
          if (d > a - o) {
            const v = t[l];
            for (; o < a; )
              e.insertBefore(n[o++], v);
          } else
            e.replaceChild(n[o++], t[l++]);
        } else
          l++;
      else
        t[l++].remove();
    }
  }
}
const Le = "_$DX_DELEGATE";
function C(e, t, n) {
  let i;
  const r = () => {
    const l = document.createElement("template");
    return l.innerHTML = e, n ? l.content.firstChild.firstChild : l.content.firstChild;
  }, s = t ? () => T(() => document.importNode(i || (i = r()), !0)) : () => (i || (i = r())).cloneNode(!0);
  return s.cloneNode = s, s;
}
function Kt(e, t = window.document) {
  const n = t[Le] || (t[Le] = /* @__PURE__ */ new Set());
  for (let i = 0, r = e.length; i < r; i++) {
    const s = e[i];
    n.has(s) || (n.add(s), t.addEventListener(s, Ht));
  }
}
function N(e, t, n) {
  n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
}
function Bt(e, t, n, i) {
  i == null ? e.removeAttributeNS(t, n) : e.setAttributeNS(t, n, i);
}
function Dt(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Ut(e, t, n, i) {
  if (i)
    Array.isArray(n) ? (e[`$$${t}`] = n[0], e[`$$${t}Data`] = n[1]) : e[`$$${t}`] = n;
  else if (Array.isArray(n)) {
    const r = n[0];
    e.addEventListener(t, n[0] = (s) => r.call(e, n[1], s));
  } else
    e.addEventListener(t, n);
}
function Wt(e, t, n = {}) {
  const i = Object.keys(t || {}), r = Object.keys(n);
  let s, l;
  for (s = 0, l = r.length; s < l; s++) {
    const o = r[s];
    !o || o === "undefined" || t[o] || (Oe(e, o, !1), delete n[o]);
  }
  for (s = 0, l = i.length; s < l; s++) {
    const o = i[s], c = !!t[o];
    !o || o === "undefined" || n[o] === c || !c || (Oe(e, o, !0), n[o] = c);
  }
  return n;
}
function L(e, t, n) {
  if (!t)
    return n ? N(e, "style") : t;
  const i = e.style;
  if (typeof t == "string")
    return i.cssText = t;
  typeof n == "string" && (i.cssText = n = void 0), n || (n = {}), t || (t = {});
  let r, s;
  for (s in n)
    t[s] == null && i.removeProperty(s), delete n[s];
  for (s in t)
    r = t[s], r !== n[s] && (i.setProperty(s, r), n[s] = r);
  return n;
}
function Vt(e, t = {}, n, i) {
  const r = {};
  return i || A(
    () => r.children = U(e, t.children, r.children)
  ), A(() => t.ref && t.ref(e)), A(() => Xt(e, t, n, !0, r, !0)), r;
}
function ye(e, t, n) {
  return T(() => e(t, n));
}
function b(e, t, n, i) {
  if (n !== void 0 && !i && (i = []), typeof t != "function")
    return U(e, t, i, n);
  A((r) => U(e, t(), r, n), i);
}
function Xt(e, t, n, i, r = {}, s = !1) {
  t || (t = {});
  for (const l in r)
    if (!(l in t)) {
      if (l === "children")
        continue;
      r[l] = je(e, l, null, r[l], n, s);
    }
  for (const l in t) {
    if (l === "children") {
      i || U(e, t.children);
      continue;
    }
    const o = t[l];
    r[l] = je(e, l, o, r[l], n, s);
  }
}
function qt(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, n) => n.toUpperCase());
}
function Oe(e, t, n) {
  const i = t.trim().split(/\s+/);
  for (let r = 0, s = i.length; r < s; r++)
    e.classList.toggle(i[r], n);
}
function je(e, t, n, i, r, s) {
  let l, o, c, f, a;
  if (t === "style")
    return L(e, n, i);
  if (t === "classList")
    return Wt(e, n, i);
  if (n === i)
    return i;
  if (t === "ref")
    s || n(e);
  else if (t.slice(0, 3) === "on:") {
    const u = t.slice(3);
    i && e.removeEventListener(u, i), n && e.addEventListener(u, n);
  } else if (t.slice(0, 10) === "oncapture:") {
    const u = t.slice(10);
    i && e.removeEventListener(u, i, !0), n && e.addEventListener(u, n, !0);
  } else if (t.slice(0, 2) === "on") {
    const u = t.slice(2).toLowerCase(), d = It.has(u);
    if (!d && i) {
      const h = Array.isArray(i) ? i[0] : i;
      e.removeEventListener(u, h);
    }
    (d || n) && (Ut(e, u, n, d), d && Kt([u]));
  } else if (t.slice(0, 5) === "attr:")
    N(e, t.slice(5), n);
  else if ((a = t.slice(0, 5) === "prop:") || (c = Tt.has(t)) || !r && ((f = Rt(t, e.tagName)) || (o = jt.has(t))) || (l = e.nodeName.includes("-")))
    a && (t = t.slice(5), o = !0), t === "class" || t === "className" ? Dt(e, n) : l && !o && !c ? e[qt(t)] = n : e[f || t] = n;
  else {
    const u = r && t.indexOf(":") > -1 && Ft[t.split(":")[0]];
    u ? Bt(e, u, t, n) : N(e, Nt[t] || t, n);
  }
  return n;
}
function Ht(e) {
  const t = `$$${e.type}`;
  let n = e.composedPath && e.composedPath()[0] || e.target;
  for (e.target !== n && Object.defineProperty(e, "target", {
    configurable: !0,
    value: n
  }), Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return n || document;
    }
  }); n; ) {
    const i = n[t];
    if (i && !n.disabled) {
      const r = n[`${t}Data`];
      if (r !== void 0 ? i.call(n, r, e) : i.call(n, e), e.cancelBubble)
        return;
    }
    n = n._$host || n.parentNode || n.host;
  }
}
function U(e, t, n, i, r) {
  for (; typeof n == "function"; )
    n = n();
  if (t === n)
    return n;
  const s = typeof t, l = i !== void 0;
  if (e = l && n[0] && n[0].parentNode || e, s === "string" || s === "number")
    if (s === "number" && (t = t.toString()), l) {
      let o = n[0];
      o && o.nodeType === 3 ? o.data !== t && (o.data = t) : o = document.createTextNode(t), n = D(e, n, i, o);
    } else
      n !== "" && typeof n == "string" ? n = e.firstChild.data = t : n = e.textContent = t;
  else if (t == null || s === "boolean")
    n = D(e, n, i);
  else {
    if (s === "function")
      return A(() => {
        let o = t();
        for (; typeof o == "function"; )
          o = o();
        n = U(e, o, n, i);
      }), () => n;
    if (Array.isArray(t)) {
      const o = [], c = n && Array.isArray(n);
      if (we(o, t, n, r))
        return A(() => n = U(e, o, n, i, !0)), () => n;
      if (o.length === 0) {
        if (n = D(e, n, i), l)
          return n;
      } else
        c ? n.length === 0 ? Te(e, o, i) : Mt(e, n, o) : (n && D(e), Te(e, o));
      n = o;
    } else if (t.nodeType) {
      if (Array.isArray(n)) {
        if (l)
          return n = D(e, n, i, t);
        D(e, n, null, t);
      } else
        n == null || n === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      n = t;
    }
  }
  return n;
}
function we(e, t, n, i) {
  let r = !1;
  for (let s = 0, l = t.length; s < l; s++) {
    let o = t[s], c = n && n[e.length], f;
    if (!(o == null || o === !0 || o === !1))
      if ((f = typeof o) == "object" && o.nodeType)
        e.push(o);
      else if (Array.isArray(o))
        r = we(e, o, c) || r;
      else if (f === "function")
        if (i) {
          for (; typeof o == "function"; )
            o = o();
          r = we(
            e,
            Array.isArray(o) ? o : [o],
            Array.isArray(c) ? c : [c]
          ) || r;
        } else
          e.push(o), r = !0;
      else {
        const a = String(o);
        c && c.nodeType === 3 && c.data === a ? e.push(c) : e.push(document.createTextNode(a));
      }
  }
  return r;
}
function Te(e, t, n = null) {
  for (let i = 0, r = t.length; i < r; i++)
    e.insertBefore(t[i], n);
}
function D(e, t, n, i) {
  if (n === void 0)
    return e.textContent = "";
  const r = i || document.createTextNode("");
  if (t.length) {
    let s = !1;
    for (let l = t.length - 1; l >= 0; l--) {
      const o = t[l];
      if (r !== o) {
        const c = o.parentNode === e;
        !s && !l ? c ? e.replaceChild(r, o) : e.insertBefore(r, n) : c && o.remove();
      } else
        s = !0;
    }
  } else
    e.insertBefore(r, n);
  return [r];
}
function Yt(e) {
  const t = Object.keys(e), n = {};
  for (let i = 0; i < t.length; i++) {
    const [r, s] = j(e[t[i]]);
    Object.defineProperty(n, t[i], {
      get: r,
      set(l) {
        s(() => l);
      }
    });
  }
  return n;
}
function Gt(e) {
  if (e.assignedSlot && e.assignedSlot._$owner)
    return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function Zt(e) {
  return (t, n) => {
    const { element: i } = n;
    return Z((r) => {
      const s = Yt(t);
      i.addPropertyChangedCallback((o, c) => s[o] = c), i.addReleaseCallback(() => {
        i.renderRoot.textContent = "", r();
      });
      const l = e(s, n);
      return b(i.renderRoot, l);
    }, Gt(i));
  };
}
function Jt(e, t, n) {
  return arguments.length === 2 && (n = t, t = {}), ht(e, t)(Zt(n));
}
const ve = "sats-connect_wallet-provider-selector_select", xe = "sats-connect_wallet-provider-selector_cancel", Ce = "sats-connect_wallet-provider-selector_open", Pe = "sats-connect_wallet-provider-selector_close", Xe = "sats-connect_wallet-provider-selector_walletOpen", qe = "sats-connect_wallet-provider-selector_walletClose", re = {
  color: "#181818",
  "font-size": "18px",
  "font-weight": "700",
  "line-height": "1.4"
}, W = {
  color: "#181818",
  "font-size": "14px",
  "font-weight": "400",
  "line-height": "1.4"
}, Qt = {
  color: "#181818",
  "font-size": "14px",
  "font-weight": "500"
};
var en = /* @__PURE__ */ C('<svg width=24 height=24 viewBox="0 0 24 24"fill=none xmlns=http://www.w3.org/2000/svg><g id=XCircle><path id=Vector d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.745 9.41566 20.7162 6.93859 18.8888 5.11118C17.0614 3.28378 14.5843 2.25496 12 2.25ZM15.5344 14.4656C15.6752 14.6078 15.7542 14.7999 15.7542 15C15.7542 15.2001 15.6752 15.3922 15.5344 15.5344C15.391 15.673 15.1994 15.7505 15 15.7505C14.8006 15.7505 14.609 15.673 14.4656 15.5344L12 13.0594L9.53438 15.5344C9.39102 15.673 9.19942 15.7505 9 15.7505C8.80059 15.7505 8.60898 15.673 8.46563 15.5344C8.32479 15.3922 8.24578 15.2001 8.24578 15C8.24578 14.7999 8.32479 14.6078 8.46563 14.4656L10.9406 12L8.46563 9.53437C8.34603 9.38865 8.28491 9.20366 8.29416 9.01537C8.30341 8.82708 8.38236 8.64896 8.51566 8.51566C8.64896 8.38236 8.82708 8.3034 9.01537 8.29416C9.20366 8.28491 9.38866 8.34603 9.53438 8.46563L12 10.9406L14.4656 8.46563C14.6114 8.34603 14.7963 8.28491 14.9846 8.29416C15.1729 8.3034 15.351 8.38236 15.4843 8.51566C15.6176 8.64896 15.6966 8.82708 15.7058 9.01537C15.7151 9.20366 15.654 9.38865 15.5344 9.53437L13.0594 12L15.5344 14.4656Z"fill=black fill-opacity=0.3>'), tn = /* @__PURE__ */ C(`<style>
          .close-selector-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: -0.25px;
          }
        `), nn = /* @__PURE__ */ C("<div role=button tabindex=0 class=close-selector-button>");
function rn(e) {
  return (() => {
    var t = en();
    return t.style.setProperty("display", "block"), Vt(t, e, !0, !0), t;
  })();
}
function sn(e) {
  function t(n) {
    (n.key === "Enter" || n.key === " ") && e.onClose();
  }
  return [tn(), (() => {
    var n = nn();
    return n.style.setProperty("position", "absolute"), n.style.setProperty("top", "16px"), n.style.setProperty("right", "16px"), n.style.setProperty("background", "none"), n.style.setProperty("border", "none"), n.style.setProperty("cursor", "pointer"), n.style.setProperty("padding", "0"), n.style.setProperty("margin", "0"), n.style.setProperty("border-radius", "50%"), n.addEventListener("click", e.onClose), n.addEventListener("keydown", t), b(n, g(rn, {})), n;
  })()];
}
var on = /* @__PURE__ */ C(`<style>
/*! modern-normalize v2.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*
Document
========
*/

/**
Use a better box model (opinionated).
*/

*,
::before,
::after {
	box-sizing: border-box;
	margin: 0; /* Remove all margins from everywhere. */
}

:host {
	/* Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3) */
	font-family:
		'DM Sans', /* Note: not part of modern-normalize, added specifically for this project. */
		system-ui,
		'Segoe UI',
		Roboto,
		Helvetica,
		Arial,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji';
	line-height: 1.15; /* 1. Correct the line height in all browsers. */
	-webkit-text-size-adjust: 100%; /* 2. Prevent adjustments of font size after orientation changes in iOS. */
	-moz-tab-size: 4; /* 3. Use a more readable tab size (opinionated). */
	tab-size: 4; /* 3 */
}

/*
Sections
========
*/

:host {
	margin: 0; /* Remove the margin in all browsers. */
}

/*
Grouping content
================
*/

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/

hr {
	height: 0; /* 1 */
	color: inherit; /* 2 */
}

/*
Text-level semantics
====================
*/

/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr[title] {
	text-decoration: underline dotted;
}

/**
Add the correct font weight in Edge and Safari.
*/

b,
strong {
	font-weight: bolder;
}

/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
	font-family:
		ui-monospace,
		SFMono-Regular,
		Consolas,
		'Liberation Mono',
		Menlo,
		monospace; /* 1 */
	font-size: 1em; /* 2 */
}

/**
Add the correct font size in all browsers.
*/

small {
	font-size: 80%;
}

/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

/*
Tabular data
============
*/

/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/

table {
	text-indent: 0; /* 1 */
	border-color: inherit; /* 2 */
}

/*
Forms
=====
*/

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

button,
input,
optgroup,
select,
textarea {
	font-family: inherit; /* 1 */
	font-size: 100%; /* 1 */
	line-height: 1.15; /* 1 */
	margin: 0; /* 2 */
}

/**
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
	text-transform: none;
}

/**
Correct the inability to style clickable types in iOS and Safari.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}

/**
Remove the inner border and padding in Firefox.
*/

::-moz-focus-inner {
	border-style: none;
	padding: 0;
}

/**
Restore the focus styles unset by the previous rule.
*/

:-moz-focusring {
	outline: 1px dotted ButtonText;
}

/**
Remove the additional ':invalid' styles in Firefox.
See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
*/

:-moz-ui-invalid {
	box-shadow: none;
}

/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/

legend {
	padding: 0;
}

/**
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
	vertical-align: baseline;
}

/**
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

/**
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
	-webkit-appearance: textfield; /* 1 */
	outline-offset: -2px; /* 2 */
}

/**
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
	-webkit-appearance: none;
}

/**
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to 'inherit' in Safari.
*/

::-webkit-file-upload-button {
	-webkit-appearance: button; /* 1 */
	font: inherit; /* 2 */
}

/*
Interactive
===========
*/

/*
Add the correct display in Chrome and Safari.
*/

summary {
	display: list-item;
}
`);
function ln() {
  return on();
}
var an = /* @__PURE__ */ C("<div class=divider><div>");
function cn() {
  return (() => {
    var e = an(), t = e.firstChild;
    return t.style.setProperty("height", "100%"), t.style.setProperty("width", "1px"), t.style.setProperty("background", "#dcdcdc"), e;
  })();
}
var un = /* @__PURE__ */ C("<div>");
function dn(e) {
  return (() => {
    var t = un();
    return t.style.setProperty("padding", "24px"), t.style.setProperty("height", "100%"), b(t, () => e.children), t;
  })();
}
var fn = /* @__PURE__ */ C("<div>");
function hn(e) {
  return (() => {
    var t = fn();
    return t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("justify-content", "center"), t.style.setProperty("align-items", "center"), t.style.setProperty("height", "100%"), b(t, () => e.children), t;
  })();
}
var pn = /* @__PURE__ */ C("<div><div>🤔</div><div>What is a wallet?</div><p>Wallets let you send, receive, store and display digital assets like Bitcoin, Stacks, Ordinals & NFTs.</p><p>Explore Bitcoin apps by connecting your wallet.");
function yn() {
  return (() => {
    var e = pn(), t = e.firstChild, n = t.nextSibling, i = n.nextSibling, r = i.nextSibling;
    return e.style.setProperty("display", "flex"), e.style.setProperty("flex-direction", "column"), e.style.setProperty("row-gap", "8px"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), t.style.setProperty("font-size", "50px"), t.style.setProperty("line-height", "140%"), A((s) => {
      var l = re, o = W, c = W;
      return s.e = L(n, l, s.e), s.t = L(i, o, s.t), s.a = L(r, c, s.a), s;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), e;
  })();
}
function Se(e) {
  var n;
  const t = (n = e.installPrompt) == null ? void 0 : n.url;
  if (!t) {
    console.error("No install prompt URL found for", e.id);
    return;
  }
  window.open(t, "_blank");
}
var gn = /* @__PURE__ */ C(`<style>
          .install-prompt-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: 2px;
          }
        `), mn = /* @__PURE__ */ C("<div><img><h1>Don't have <!>?</h1><p>Download it on the Chrome web store.</p><div class=install-prompt-button role=button tabindex=0>Get");
function bn(e) {
  function t(i) {
    (i.key === "Enter" || i.key === " ") && Se(e.option);
  }
  function n() {
    Se(e.option);
  }
  return [gn(), (() => {
    var i = mn(), r = i.firstChild, s = r.nextSibling, l = s.firstChild, o = l.nextSibling;
    o.nextSibling;
    var c = s.nextSibling, f = c.nextSibling;
    return i.style.setProperty("display", "flex"), i.style.setProperty("flex-direction", "column"), i.style.setProperty("align-items", "center"), i.style.setProperty("row-gap", "16px"), r.style.setProperty("border-radius", "12px"), r.style.setProperty("height", "64px"), r.style.setProperty("width", "64px"), r.style.setProperty("object-fit", "cover"), b(s, () => e.option.name, o), f.addEventListener("click", n), f.addEventListener("keydown", t), A((a) => {
      var u = e.option.icon, d = e.option.name, h = {
        ...re,
        "text-align": "center"
      }, v = W, y = {
        ...Qt,
        cursor: "pointer",
        "border-radius": "12px",
        background: "#181818",
        color: "white",
        padding: "12px 16px"
      };
      return u !== a.e && N(r, "src", a.e = u), d !== a.t && N(r, "alt", a.t = d), a.a = L(s, h, a.a), a.o = L(c, v, a.o), a.i = L(f, y, a.i), a;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), i;
  })()];
}
var wn = /* @__PURE__ */ C('<svg width=20 height=20 viewBox="0 0 20 20"xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=9.05 stroke=black stroke-width=1.9 fill=none stroke-dasharray="42.65 14.22"stroke-dashoffset=0><animateTransform attributeName=transform attributeType=XML type=rotate from="0 10 10"to="360 10 10"dur=0.75s repeatCount=indefinite>'), vn = /* @__PURE__ */ C("<div>");
const xn = () => wn();
function Cn() {
  return (() => {
    var e = vn();
    return e.style.setProperty("display", "flex"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), e.style.setProperty("height", "100%"), e.style.setProperty("animation", "spin 1s linear infinite"), b(e, g(xn, {})), e;
  })();
}
var Pn = /* @__PURE__ */ C("<div><img><h1>Opening <!>...</h1><p>Confirm the operation in ");
function Sn(e) {
  return (() => {
    var t = Pn(), n = t.firstChild, i = n.nextSibling, r = i.firstChild, s = r.nextSibling;
    s.nextSibling;
    var l = i.nextSibling;
    return l.firstChild, t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("align-items", "center"), t.style.setProperty("row-gap", "16px"), n.style.setProperty("border-radius", "12px"), n.style.setProperty("height", "64px"), n.style.setProperty("width", "64px"), n.style.setProperty("object-fit", "cover"), b(i, () => e.option.name, s), b(l, () => e.option.name, null), b(t, g(Cn, {}), null), A((o) => {
      var c = e.option.icon, f = e.option.name, a = {
        ...re,
        "text-align": "center"
      }, u = W;
      return c !== o.e && N(n, "src", o.e = c), f !== o.t && N(n, "alt", o.t = f), o.a = L(i, a, o.a), o.o = L(l, u, o.o), o;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), t;
  })();
}
var _n = /* @__PURE__ */ C("<div><div tabindex=0><img><div>");
function En(e) {
  function t() {
    e.onProviderSelected(e.id);
  }
  const n = F(() => ke(e) ? "button" : "link");
  function i(u) {
    if (n() === "link") {
      u.key === "Enter" && t();
      return;
    }
    if (n() === "button") {
      (u.key === "Enter" || u.key === " ") && t();
      return;
    }
  }
  const [r, s] = j(!1), [l, o] = j(!1), c = () => r() || l(), f = "rgba(24, 24, 24, 0.20)", a = "rgba(24, 24, 24, 0.60)";
  return (() => {
    var u = _n(), d = u.firstChild, h = d.firstChild, v = h.nextSibling;
    return u.style.setProperty("aspect-ratio", "1 / 1"), u.style.setProperty("overflow", "hidden"), d.style.setProperty("display", "flex"), d.style.setProperty("flex-direction", "column"), d.style.setProperty("row-gap", "12px"), d.style.setProperty("align-items", "center"), d.style.setProperty("cursor", "pointer"), d.style.setProperty("outline", "none"), d.style.setProperty("padding-top", "10px"), d.addEventListener("click", t), d.addEventListener("keydown", i), d.addEventListener("mouseenter", () => s(!0)), d.addEventListener("mouseleave", () => s(!1)), d.addEventListener("focus", () => o(!0)), d.addEventListener("blur", () => o(!1)), h.style.setProperty("width", "56px"), h.style.setProperty("height", "56px"), h.style.setProperty("object-fit", "cover"), h.style.setProperty("border-radius", "12px"), b(v, () => e.name), A((y) => {
      var z = n(), $ = c() ? `6px solid ${f}` : "none", P = e.icon, _ = e.name, E = {
        ...W,
        color: c() ? a : void 0,
        "text-align": "center"
      };
      return z !== y.e && N(d, "role", y.e = z), $ !== y.t && ((y.t = $) != null ? h.style.setProperty("outline", $) : h.style.removeProperty("outline")), P !== y.a && N(h, "src", y.a = P), _ !== y.o && N(h, "alt", y.o = _), y.i = L(v, E, y.i), y;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), u;
  })();
}
var kn = /* @__PURE__ */ C('<link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&amp;display=swap"rel=stylesheet>'), $n = /* @__PURE__ */ C("<div class=side-panel>"), An = /* @__PURE__ */ C('<div><div></div><div><div class=card-width-container><div class=card-height-container><div class=card><div class=card-grid><div class=main-panel><div></div><div></div><div class=wallets-grid-container data-desc="wallet grid container for padding"><div class=wallets-grid data-desc="wallet grid container">'), Ln = /* @__PURE__ */ C(`<div><style>
        @keyframes wallet-selector-fade-in {
          from {opacity: 0; transform: translateY(40px);}
          to {opacity: 1; transform: translateY(0);}
        }

        @keyframes wallet-selector-fade-out {
          from {opacity: 1; transform: translateY(0);}
          to {opacity: 0; transform: translateY(40px);}
        }
        @keyframes wallet-selector-blur-in {
          from {opacity: 0; backdrop-filter: blur(0px);}
          to {opacity: 1; backdrop-filter: blur(10px);}
        }

        @keyframes wallet-selector-blur-out {
          from {opacity: 1; backdrop-filter: blur(10px);}
          to {opacity: 0; backdrop-filter: blur(0px);}
        }
      </style><style>`);
const G = "24px";
function On() {
  const [e, t] = j(), [n, i] = j(), [r, s] = j();
  function l() {
    const p = e(), x = r();
    return !(!p || !x || !p.contains(x) || getComputedStyle(x).display === "none");
  }
  const [o, c] = j(!1), [f, a] = j(!1), [u, d] = j([]), [h, v] = j({
    type: "none"
  }), y = () => u().some((p) => jn(p)), z = () => c(!1);
  function $() {
    const p = new CustomEvent(xe, {
      bubbles: !0,
      composed: !0
    });
    window.dispatchEvent(p), z();
  }
  function P(p) {
    p.key === "Escape" && $();
  }
  Fe(() => {
    if (o()) {
      window.addEventListener("keydown", P);
      return;
    }
    window.removeEventListener("keydown", P);
  });
  function _(p) {
    const x = u().find((K) => K.id === p);
    if (ke(x)) {
      l() ? v({
        type: "install-wallet-prompt",
        option: x
      }) : Se(x);
      return;
    }
    const O = new CustomEvent(ve, {
      detail: p,
      bubbles: !0,
      composed: !0
    });
    window.dispatchEvent(O);
  }
  function E(p) {
    mt(() => {
      c(!0), a(!0);
      const x = p.detail.options;
      d(x), x.some((O) => !O.installPrompt) ? v({
        type: "explainer"
      }) : v({
        type: "none"
      });
    });
  }
  function R() {
    c(!1);
  }
  const se = () => {
    o() || a(!1);
  };
  function Ye(p) {
    const x = p.detail;
    v({
      type: "opening-wallet",
      option: u().find((O) => O.id === x)
    });
  }
  function Ge() {
    v({
      type: "explainer"
    });
  }
  bt(() => {
    window.addEventListener(Ce, E), window.addEventListener(Pe, R), window.addEventListener(Xe, Ye), window.addEventListener(qe, Ge), document.head.appendChild(kn());
  }), Me(() => {
    window.removeEventListener(Ce, E), window.removeEventListener(Pe, R);
  });
  function Ze(p) {
    const x = p.target;
    if (!x)
      return;
    const O = n();
    O && (O.contains(x) || $());
  }
  return (() => {
    var p = Ln(), x = p.firstChild, O = x.nextSibling;
    return ye(t, p), p.style.setProperty("inset", "0"), p.addEventListener("click", Ze), p.addEventListener("keydown", () => {
      console.log("Inside root keydown");
    }), b(p, g(ln, {}), x), b(O, () => `
        .card-width-container {
          container: card-width-container / inline-size;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 740px;
        }

        .card-height-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          height: 100%;
          width: 100%;
        }

        .card {
          min-height: 340px;
          max-height: calc(100vh - 8rem);
          width: 100%;
          border-top-left-radius: ${G};
          border-top-right-radius: ${G};

          background: rgb(196, 177, 217);
          overflow: hidden;

          display: flex;
          flex-direction: column;

          position: "relative"; /* For the close button */
          background-color: #ffffff;
          display: ${f() ? "block" : "none"};

          box-shadow: 0px 8px 64px 0px rgba(0, 0, 0, 0.25);
          animation: ${o() ? "wallet-selector-fade-in 0.4s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-fade-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards"};
        }

        .card-grid {
          flex-grow: 1;
          height: 100%;
          
          display: grid;
          grid-template-columns: 1fr;
          grid-template-areas: "mainPanel";
        }

        .main-panel {
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          grid-area: mainPanel;
        }

        .wallets-grid-container {
          overflow: auto;
          flex-grow: 1;
        }

        .wallets-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          align-content: start;

          padding-left: 24px;
          padding-right: 24px;
          padding-bottom: 40px;
        }

        .divider {
          display: none;
          grid-area: divider;
        }

        .side-panel {
          display: none;
          grid-area: sidePanel;
        }

        @container card-width-container (width > 400px) {
          .card-height-container {
            justify-content: center;
          }

          .card {
            max-width: calc(100vw - 2rem);
            max-height: 460px;
            ${y() ? "" : "width: 360px;"}
            border-bottom-left-radius: ${G};
            border-bottom-right-radius: ${G};
          }

          .card-grid {
            grid-template-columns: ${y() ? "5fr auto 4fr" : "1fr"};
            grid-template-areas: ${y() ? '"mainPanel divider sidePanel"' : '"mainPanel"'};
          }

          .divider {
            display: block;
          }

          .side-panel {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      `), b(p, g(he, {
      get when() {
        return f();
      },
      get children() {
        var K = An(), B = K.firstChild, X = B.nextSibling, Je = X.firstChild, Qe = Je.firstChild, H = Qe.firstChild, oe = H.firstChild, et = oe.firstChild, le = et.firstChild, ae = le.nextSibling, tt = ae.nextSibling, nt = tt.firstChild;
        return K.style.setProperty("position", "fixed"), K.style.setProperty("inset", "0"), B.style.setProperty("background-color", "#FFFFFF80"), B.style.setProperty("position", "absolute"), B.style.setProperty("inset", "0"), X.style.setProperty("display", "flex"), X.style.setProperty("justify-content", "center"), X.style.setProperty("align-items", "center"), X.style.setProperty("height", "100%"), ye(i, H), H.addEventListener("animationend", se), b(le, () => y() ? "Choose wallet to connect" : "Don't have a wallet?"), b(ae, () => y() ? "Start by selecting with one of the wallets below and confirming the connection." : "Start by installing one of the wallets below."), b(nt, g(At, {
          get each() {
            return u();
          },
          children: (k) => g(En, $t(k, {
            onProviderSelected: _
          }))
        })), b(oe, g(he, {
          get when() {
            return h().type !== "none";
          },
          get children() {
            return g(cn, {});
          }
        }), null), b(oe, g(he, {
          get when() {
            return h().type !== "none";
          },
          get children() {
            var k = $n();
            return ye(s, k), b(k, g(dn, {
              get children() {
                return g(hn, {
                  get children() {
                    return g(Lt, {
                      fallback: null,
                      get children() {
                        return [g(pe, {
                          get when() {
                            return h().type === "install-wallet-prompt";
                          },
                          get children() {
                            return g(bn, {
                              get option() {
                                return h().option;
                              }
                            });
                          }
                        }), g(pe, {
                          get when() {
                            return h().type === "explainer";
                          },
                          get children() {
                            return g(yn, {});
                          }
                        }), g(pe, {
                          get when() {
                            return h().type === "opening-wallet";
                          },
                          get children() {
                            return g(Sn, {
                              get option() {
                                return h().option;
                              }
                            });
                          }
                        })];
                      }
                    });
                  }
                });
              }
            })), k;
          }
        }), null), b(H, g(sn, {
          onClose: $
        }), null), A((k) => {
          var ce = o() ? "wallet-selector-blur-in 0.2s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-blur-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards", it = {
            ...re,
            margin: "0",
            "padding-top": "24px",
            "padding-left": "24px",
            "padding-right": "24px",
            "padding-bottom": "16px"
          }, rt = {
            ...W,
            "padding-left": "24px",
            "padding-right": "24px",
            "padding-bottom": "30px"
          };
          return ce !== k.e && ((k.e = ce) != null ? B.style.setProperty("animation", ce) : B.style.removeProperty("animation")), k.t = L(le, it, k.t), k.a = L(ae, rt, k.a), k;
        }, {
          e: void 0,
          t: void 0,
          a: void 0
        }), K;
      }
    }), null), A(() => (f() ? "fixed" : "static") != null ? p.style.setProperty("position", f() ? "fixed" : "static") : p.style.removeProperty("position")), p;
  })();
}
const Ee = "sats-connect-wallet-provider-selector", ge = Ee;
function He() {
  return document.getElementById(Ee);
}
function Nn() {
  if (customElements.get(ge))
    return;
  Jt(ge, On);
  const e = document.createElement(ge);
  e.id = Ee, e.style.position = "relative", e.style.zIndex = "999999", document.body.appendChild(e);
}
function zn() {
  const e = He();
  e && e.remove();
}
function ke(e) {
  return !!e.installPrompt;
}
function jn(e) {
  return !ke(e);
}
function Rn(e) {
  return new Promise((t, n) => {
    if (!He()) {
      n("Failed to detect the wallet provider selector.");
      return;
    }
    function r() {
      window.removeEventListener(ve, s), window.removeEventListener(xe, l);
    }
    function s(c) {
      t(c.detail), r();
    }
    function l() {
      n(), r();
    }
    window.addEventListener(ve, s), window.addEventListener(xe, l);
    const o = new CustomEvent(Ce, {
      detail: e
    });
    window.dispatchEvent(o);
  });
}
function In(e) {
  const t = new CustomEvent(Xe, {
    detail: e
  });
  window.dispatchEvent(t);
}
function Fn() {
  const e = new CustomEvent(qe);
  window.dispatchEvent(e);
}
function Mn() {
  const e = new CustomEvent(Pe);
  window.dispatchEvent(e);
}
export {
  zn as cleanup,
  Mn as close,
  Ee as elementId,
  ge as elementName,
  He as getWalletProviderSelectorElement,
  ke as hasInstallPrompt,
  jn as isInstalled,
  Nn as loadSelector,
  Rn as selectWalletProvider,
  Fn as walletClose,
  In as walletOpen
};
